import { useId, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Collapse, Box } from "@mui/material";

const CustomSimpleAccordion = ({ title, content, defaultExpanded = false }) => {
  const [isOpen, setIsOpen] = useState(defaultExpanded);
  const panelId = useId();

  const handleToggle = () => {
    setIsOpen((open) => !open);
  };

  return (
    <div
      className="qub-simple-accordion"
      style={{
        border: "1px solid #ccc",
        overflow: "hidden",
      }}
    >
      <div
        onClick={handleToggle}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            handleToggle();
          }
        }}
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
        aria-controls={panelId}
        style={{
          cursor: "pointer",
          padding: "10px 15px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>{title}</div>
        <ExpandMoreIcon
          style={{
            transition: "transform 0.3s ease",
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </div>
      <Collapse id={panelId} in={isOpen} timeout="auto">
        <Box
          sx={{
            padding: "10px 15px",
            backgroundColor: "#fff",
          }}
        >
          {content}
        </Box>
      </Collapse>
    </div>
  );
};

export default CustomSimpleAccordion;
